module.exports = __webpack_public_path__ + "static/media/twitterWhite.d01fc280.png";